import { createSlice } from "@reduxjs/toolkit";

// Create a slice for dashboard
const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    cardCount: {},
    salseTrend: {},
    dealerPerformance: {},
    dealerOnboardingTrend: {},
    activeCompaign: {},
    searchTerm: "",
    loading: false,
    error: null,
  },
  reducers: {
    setCardCount: (state, action) => {
      state.cardCount = action.payload.data || {};
      state.loading = false;
    },
    setSalesTrend: (state, action) => {
      state.salseTrend = action.payload.data || {};
      state.loading = false;
    },
    setDealersPerformance: (state, action) => {
      state.dealerPerformance = action.payload.data || {};
      state.loading = false;
    },
    setDealersOnboardingTrend: (state, action) => {
      state.dealerOnboardingTrend = action.payload.data || {};
      state.loading = false;
    },
    setActiveCompaign: (state, action) => {
      state.activeCompaign = action.payload.data || {};
      state.loading = false;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectStockLoading = (state) => state.dashboard.loading;
export const selectStockError = (state) => state.dashboard.error;
export const selectCardCount = (state) => state.dashboard.cardCount;
export const selectSalseTrend = (state) => state.dashboard.salseTrend;
export const selectDealersPerformance = (state) => state.dashboard.dealerPerformance;
export const selectDealersOnboardingTrend = (state) => state.dashboard.dealerOnboardingTrend;
export const selectActiveCompaign = (state) => state.dashboard.activeCompaign;
export const selectSearchTerm = (state) => state.dashboard.searchTerm;

// Export the reducer to include in the store
export const {
  setCardCount,
  setSalesTrend,
  setDealersPerformance,
  setDealersOnboardingTrend,
  setActiveCompaign,
  setSearchTerm,
} = DashboardSlice.actions;
export default DashboardSlice.reducer;
